function quickAdd(button) {
    const body = {
        items: [
            {
                id: button.dataset.quickAddVariant,
                quantity: 1
            }
        ]
    }
    
    const options = {
        important: false
    };
      
    window.liquidAjaxCart.add(body, options);
}
   